import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { TasksStatuses, TasksPriorities } from '../../constants'
import { ResidualRisksRates } from 'src/common/constants'

const formatRiskId = ({
    questionnaire,
    ...elseData
}) => {
    const riskId = elseData.relatedRisk?.secondary_id ?? elseData.secondary_id;
    const isGeneral = elseData.relatedRisk?.is_general;
    
    if (questionnaire === 'general' || isGeneral) {
        return `R${riskId}`
    } else if(questionnaire === 'software'){
        return `A${elseData.asset_id}/R${riskId}`
    }
    else if (questionnaire === 'other_asset') {
        return `OA${elseData.asset_id}/R${riskId}`;
    }
    else if (questionnaire === 'data_breach_incident') {
        return `IN${elseData.case_secondary_id}/R${riskId}`
    } else if (questionnaire === 'tom') {
        if (elseData?.is_mitigation) {
            return `A${ elseData?.case_secondary_id ?? elseData?.secondary_id}/R${elseData.relatedRisk?.secondary_id}`;
        } else {
            return `R${elseData?.risk_secondary_id}`;
        }
    }

    return '';
}

const formatTaskId = ({
    questionnaire,
    ...elseData
}) => {
    const isGeneral = elseData.relatedRisk?.is_general;
    if(questionnaire === 'general' || isGeneral) {
        return `R${elseData.relatedRisk?.secondary_id}/T${elseData.secondary_id}`
    } else if(questionnaire === 'software'){
        return `A${elseData.asset_id}/R${elseData.relatedRisk?.secondary_id}/T${elseData.secondary_id}`
    }
    else if(questionnaire === 'other_asset'){
        return `OA${elseData.asset_id}/R${elseData.relatedRisk?.secondary_id}/T${elseData.secondary_id}`
    }
    else if (questionnaire === 'data_breach_incident') {
        return `IN${elseData.case_secondary_id}/R${elseData.relatedRisk?.secondary_id}/T${elseData.secondary_id}`
    } else if (questionnaire === 'tom') {
        if (elseData?.is_mitigation) {
            return `A${ elseData?.case_secondary_id ?? elseData?.secondary_id}/R${elseData.relatedRisk?.secondary_id}/T${elseData?.secondary_id}`;
        } else {
            return `T${elseData?.secondary_id}`;
        }
    }

    return '';
}

export const tableAllRisksColumnsRenderer = ({
    t,
    dateUtils,
    onDeleteButtonClicked,
    history
}) => {
    return [
        {
            dataField: 'result_color',
            text: t('Risk'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '80px'
            },
            key: 1,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span
                            className='dt-risk-rating-bullet'
                            style={{
                                backgroundColor: `#${cellContent}`,
                                opacity: row.is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'id',
            text: t('Risk ID'),
            sort: false,
            key: 2,
            style: {
                width: '80px'
            },
            formatter: (cellContent, row) => {
                return (
                    <span
                        style={{
                            cursor: !row.is_deleted && 'pointer'
                        }}
                        onClick={() =>
                            !row.is_deleted &&
                            history.push(
                                `/admin/risk-management/${row.id}/details?incomming_tab=all-risks`
                            )
                        }
                        className={!row.is_deleted ? 'btn-link' : ''}
                    >
                        {formatRiskId(
                            row
                        )}
                    </span>
                )
            }
        },
        {
            dataField: 'title',
            text: t('Risk Title'),
            sort: false,
            key: 3,
            style: {
                width: '140px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.acceptance?.accepted && (
                            <div>
                                <span
                                    className='badge bg-success text-white rounded'
                                    id={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('Accepted')}
                                </span>

                                <UncontrolledTooltip
                                    placement="top"
                                    target={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('This risk has been accepted.')}<br />
                                    {t('Justification')}: {row.acceptance?.reason}
                                </UncontrolledTooltip>
                            </div>
                        )}
                        <span
                            style={{
                                cursor: !row.is_deleted && 'pointer'
                            }}
                            onClick={() =>
                                !row.is_deleted &&
                                history.push(
                                    `/admin/risk-management/${row.id}/details?incomming_tab=all-risks`
                                )
                            }
                            className={!row.is_deleted ? 'btn-link' : ''}
                        >{cellContent}</span>
                    </div>
                )
            }
        },
        {
            dataField: 'case_id',
            text: t('Report ID'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '100px'
            },
            sort: false,
            key: 4,
            formatter: (cellContent, row) => {
                return (
                    <div className='text-center'>
                        {(row?.questionnaire !== 'software' && row?.questionnaire !== 'general') ? row?.report_case?.caseId : '---'}
                    </div>
                )
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 5,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.main?.name)}</div>
            }
        },
        {
            dataField: 'category',
            text: t('Sub Category'),
            sort: false,
            key: 6,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.subCategory?.name)}</div>
            }
        },
        {
            dataField: 'residual_risk',
            text: t('Residual Risk Rate'),
            sort: false,
            key: 7,
            style: {
                width: '120px'
            },
            formatter: (cellContent, {
                is_deleted
            }) => {
                return (
                    <div>
                        <span title={t(ResidualRisksRates[cellContent]?.title)} className="dt-risk-rating-bullet"
                            style={{
                                backgroundColor: `${ResidualRisksRates[cellContent]?.color}`,
                                opacity: is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'owner_name',
            text: t('Risk owner'),
            sort: false,
            key: 8,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'manager',
            text: t('Risk Manager'),
            sort: false,
            key: 9,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'tasks',
            text: t('Mitigation'),
            style: {
                maxWidth: '200px',
                wordWrap: 'break-word'
            },
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return cellContent && cellContent.length
                    ? cellContent.map((task, i) => {
                        const canRedirect = task.status?.toLowerCase() !== 'deleted'

                        return (
                            <span 
                                onClick={() => {
                                    canRedirect &&
                                    history.push(
                                        `/admin/risk-management/task/${task.id}/details?incomming_tab=all-risks`
                                    )
                                }} 
                                key={task.id}
                                className={canRedirect ? 'btn-link' : ''}
                                style={{
                                    cursor: canRedirect ? 'pointer' : ''
                                }}
                            >
                                {`T${task.secondary_id}`}
                                <span hidden={i === cellContent.length - 1}>
                                    ,{' '}
                                </span>
                            </span>
                        )
                    })
                    : null
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 11,
            sort: true,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'is_deleted',
            text: t('Action'),
            headerStyle: {
                paddingInline: '30px',
                textAlign: 'center'
            },
            sort: false,
            key: 12,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center'>
                        {row.is_deleted ? (
                            <span className='text-danger'>
                                {t('DELETED')}
                            </span>
                        ) : (
                            <Button
                                onClick={() => onDeleteButtonClicked(row)}
                                outline
                                color='danger'
                                className='border-0'
                            >
                                <i className='ri-delete-bin-line font-size-24' />
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]
}

export const tableMitigationTasksColumnsRenderer = ({
    t,
    dateUtils,
    history,
    Organization
}) => {
    return [
        {
            dataField: 'secondary_id',
            text: t('Task ID'),
            key: 0,
            style: {
                width: '80px'
            },
            formatter: (cellContent, row) => {
                const canRedirect = row.status?.toLowerCase() !== 'deleted'

                return (
                    <span
                        style={{
                            cursor: canRedirect && 'pointer'
                        }}
                        className={canRedirect ? 'btn-link' : ''}
                        onClick={() =>
                            canRedirect &&
                            history.push(
                                `/admin/risk-management/task/${row.id}/details?incomming_tab=mitigation-tasks`
                            )
                        }
                    >
                        {formatTaskId(row)}
                    </span>
                )
            }
        },
        {
            dataField: 'name',
            text: t('Title'),
            key: 1,
            style: {
                width: '140px'
            },
            formatter: (cell, {
                id,
                is_recurring,
                recurrence_secondary_id,
                status
            }) => {
                const canRedirect = status?.toLowerCase() !== 'deleted'

                return (
                    <div
                        style={{
                            cursor: canRedirect && 'pointer'
                        }}
                        className={canRedirect ? 'btn-link' : ''}
                        onClick={() =>
                            canRedirect &&
                            history.push(
                                `/admin/risk-management/task/${id}/details?incomming_tab=mitigation-tasks`
                            )
                        }
                    >
                        {is_recurring && recurrence_secondary_id && (
                            <>
                                <i
                                    className="ri-repeat-2-line text-info me-1 font-size-18 align-middle"
                                    id={`recurring-task-${id}-tooltip`}
                                />
                                <UncontrolledTooltip
                                    placement="top"
                                    target={`recurring-task-${id}-tooltip`}
                                >
                                    {t('Recurring task')}
                                </UncontrolledTooltip>
                            </>
                        )}
                        {cell}{recurrence_secondary_id ? `-${recurrence_secondary_id}` : ''}
                    </div>
                )
            }
        },
        {
            dataField: 'relatedRisk',
            text: t('Related Risk'),
            sort: false,
            key: 2,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                const canRedirect = !row.relatedRisk.deleted

                return (
                    <span
                        style={{
                            cursor: canRedirect && 'pointer'
                        }}
                        className={canRedirect ? 'btn-link' : ''}
                        onClick={() =>
                            canRedirect &&
                            history.push(
                                `/admin/risk-management/${row.relatedRisk.id}/details?incomming_tab=mitigation-tasks`
                            )
                        }
                    >
                        {formatRiskId(row)}
                    </span>
                )
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 3,
            sort: true,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'endedAt',
            text: t('Deadline'),
            key: 4,
            sort: true,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex flex-column justify-content-start align-items-baseline'>
                        {dateUtils.convertTimeStampToDate(
                            row.ended_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                        {row.ended_at && row.overdue && row.status.toLowerCase() !== 'closed' && (
                            <span className='bg-danger me-1 badge badge-danger'>
                                {t('Overdue')}
                            </span>
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'manager',
            text: t('Task Manager'),
            sort: false,
            key: 5,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'owner',
            text: t('Task Owner'),
            sort: false,
            key: 6,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 7,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.name)}</div>
            }
        },
        {
            dataField: 'priority',
            text: t('Priority'),
            sort: false,
            key: 8,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                const taskPriority = TasksPriorities[row.priority]
                return (
                    <div className='d-flex justify-content-start'>
                        <span
                            style={{
                                color: `${taskPriority.color}`
                            }}
                        >
                            {taskPriority.icon}
                        </span>

                        <span style={{ marginLeft: '4px' }}>
                            {t(taskPriority.title)}
                        </span>
                    </div>
                )
            }
        },
        {
            dataField: 'status',
            text: t('Status'),
            sort: false,
            key: 9,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                const taskStatus = TasksStatuses[row.status]
                return (
                    <div
                        className='dt-task-status text-dark'
                        style={{
                            backgroundColor: `${taskStatus.color}`
                        }}
                    >
                        {t(taskStatus.title)}
                    </div>
                )
            }
        },
        {
            dataField: 'deleted_at',
            text: t('Deletion Date'),
            sort: false,
            key: 10,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.deleted_at
                            ? dateUtils.convertTimeStampToDate(
                                    row.deleted_at,
                                    INTERNATIONAL_DATE_FORMAT
                                )
                            : null}
                    </div>
                )
            }
        }
    ]
}

export const tableMyRisksColumnsRenderer = ({
    t,
    dateUtils,
    onDeleteButtonClicked,
    history
}) => {
    return [
        {
            dataField: 'result_color',
            text: t('Risk'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '80px'
            },
            key: 1,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span
                            className='dt-risk-rating-bullet'
                            style={{
                                backgroundColor: `#${cellContent}`,
                                opacity: row.is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'id',
            text: t('Risk ID'),
            sort: false,
            key: 2,
            style: {
                width: '80px'
            },
            formatter: (cellContent, row) => {
                return (
                    <span
                        style={{
                            cursor: !row.is_deleted && 'pointer'
                        }}
                        onClick={() =>
                            !row.is_deleted &&
                            history.push(
                                `/admin/risk-management/${row.id}/details?incomming_tab=my-risks`
                            )
                        }
                        className={!row.is_deleted ? 'btn-link' : ''}
                    >
                        {formatRiskId(
                            row
                        )}
                    </span>
                )
            }
        },
        {
            dataField: 'title',
            text: t('Risk Title'),
            sort: false,
            key: 3,
            style: {
                width: '140px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.acceptance?.accepted && (
                            <div>
                                <span
                                    className='badge bg-success text-white rounded'
                                    id={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('Accepted')}
                                </span>

                                <UncontrolledTooltip
                                    placement="top"
                                    target={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('This risk has been accepted.')}<br />
                                    {t('Justification')}: {row.acceptance?.reason}
                                </UncontrolledTooltip>
                            </div>
                        )}
                        <span
                            style={{
                                cursor: !row.is_deleted && 'pointer'
                            }}
                            onClick={() =>
                                !row.is_deleted &&
                                history.push(
                                    `/admin/risk-management/${row.id}/details?incomming_tab=my-risks`
                                )
                            }
                            className={!row.is_deleted ? 'btn-link' : ''}
                        >{cellContent}</span>
                    </div>
                )
            }
        },
        {
            dataField: 'case_id',
            text: t('Report ID'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '100px'
            },
            sort: false,
            key: 4,
            formatter: (cellContent, row) => {
                return (
                    <div className='text-center'>
                        {(row?.questionnaire !== 'software' && row?.questionnaire !== 'general') ? row?.report_case?.caseId : '---'}
                    </div>
                )
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 5,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.main?.name)}</div>
            }
        },
        {
            dataField: 'category',
            text: t('Sub Category'),
            sort: false,
            key: 6,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.subCategory?.name)}</div>
            }
        },
        {
            dataField: 'residual_risk',
            text: t('Residual Risk Rate'),
            sort: false,
            key: 7,
            style: {
                width: '120px'
            },
            formatter: (cellContent, {
                is_deleted
            }) => {
                return (
                    <div>
                        <span title={t(ResidualRisksRates[cellContent]?.title)} className="dt-risk-rating-bullet"
                            style={{
                                backgroundColor: `${ResidualRisksRates[cellContent]?.color}`,
                                opacity: is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'owner_name',
            text: t('Risk owner'),
            sort: false,
            key: 8,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'manager',
            text: t('Risk Manager'),
            sort: false,
            key: 9,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'tasks',
            text: t('Mitigation'),
            style: {
                maxWidth: '200px',
                wordWrap: 'break-word'
            },
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return cellContent && cellContent.length
                    ? cellContent.map((task, i) => {
                        const canRedirect = task.status?.toLowerCase() !== 'deleted'

                        return (
                            <span 
                                onClick={() => {
                                    canRedirect &&
                                    history.push(
                                        `/admin/risk-management/task/${task.id}/details?incomming_tab=my-risks`
                                    )
                                }} 
                                key={task.id}
                                className={canRedirect ? 'btn-link' : ''}
                                style={{
                                    cursor: canRedirect ? 'pointer' : ''
                                }}
                            >
                                {`T${task.secondary_id}`}
                                <span hidden={i === cellContent.length - 1}>
                                    ,{' '}
                                </span>
                            </span>
                        )
                    })
                    : null
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 11,
            sort: true,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'is_deleted',
            text: t('Action'),
            headerStyle: {
                paddingInline: '30px',
                textAlign: 'center'
            },
            sort: false,
            key: 12,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center'>
                        {row.is_deleted ? (
                            <span className='text-danger'>
                                {t('DELETED')}
                            </span>
                        ) : (
                            <Button
                                onClick={() => onDeleteButtonClicked(row)}
                                outline
                                color='danger'
                                className='border-0'
                            >
                                <i className='ri-delete-bin-line font-size-24' />
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]
}

export const riskIdGenerator = ({ risk }) => {
    return formatRiskId({
        questionnaire: risk.questionnaire,
        asset_id: risk.assetId || risk.asset_id,
        secondary_id: risk.secondaryId || risk.secondary_id,
        case_secondary_id: risk.caseSecondaryId || risk.case_secondary_id
    })
}

export const riskDetailPageHeaderText = ({ risk }) => {
    return ''
}

export const taskDetailPageHeaderText = ({ task }) => {
    return ''
}

export const taskIdGenerator = ({ task }) => {
    return ''
}